import script from "./NavElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavElement.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__